import React from 'react';
import PropTypes from 'prop-types';

var SvgContextMixin = require('./svgContextMixin'),
  SvgPopoverMixin = require('./svgPopoverMixin');

var SvgPopover = React.createClass({
  mixins: [SvgContextMixin, SvgPopoverMixin],

  statics: {},

  propTypes: {
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    assessmentData: PropTypes.object,
    width: PropTypes.number,
    height: PropTypes.number
  },

  getDefaultProps(){
    return {
      width: 10,
      height: 10
    };
  },

  render(){

    var {x, y, width, height} = this.props;

    var popoverRect = this.getPopoverRect(x, y, width, height),
      popoverPath = this.getPopoverLinePath(popoverRect);


    return (
      <polyline
        points={popoverPath.map((point) => (point.join(','))).join(" ")}
      />
    );
  }

});


module.exports = SvgPopover;
